const {store, AoflElement, clickTrackerMixin} = aofljs;
/**
 * @summary HomeTestimonial
 * @class HomeTestimonial
 * @extends {clickTrackerMixin(AoflElement)}
 */
class HomeTestimonial extends clickTrackerMixin(AoflElement) {
  /**
   * Creates an instance of HomeTestimonial.
   * @memberof HomeTestimonial
   */
  constructor() {
    super(store);
  }

  /**
   *
   * @readonly
   * @static
   * @memberof HomeTestimonial
   */
  static get is() {
    return 'home-testimonial';
  }
  /**
   *
   * @memberof HomePage
   */
  showTestimonialsPopup() {
    store.commit([
      {
        stateAlias: 'modals',
        mutationId: 'showModal',
        payload: 'testimonialsPopup'
      }
    ]);
  }
}

window.customElements.define(HomeTestimonial.is, HomeTestimonial);



// WEBPACK FOOTER //
// ./home/en-US/js/home-testimonial/home-testimonial.js